import { Component, input } from '@angular/core';

import { TranslateModule } from '@ngx-translate/core';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import {
    ColumnConfig,
    ColumnValue,
} from '@app/shared/services/view-configs/column-creator';
import { TableRowData } from '@app/shared/models/table-data-types';

/**
 * Marks a bundle (Mappe) or delivery note that belongs to a bundle group
 * (Mappengruppe). Grouped items stay visible in their list but can only be
 * checked in via their group, which the tooltip explains.
 */
@Component({
    selector: 'app-bundle-group-membership-display',
    template: `
        <div class="tw-flex tw-justify-center">
            @if (isGrouped()) {
                <mat-icon
                    fontSet="material-symbols-outlined"
                    class="tw-text-primary"
                    [matTooltip]="tooltipKey() | translate">
                    inventory_2
                </mat-icon>
            }
        </div>
    `,
    standalone: true,
    imports: [TranslateModule, MatIconModule, MatTooltipModule],
})
export class BundleGroupMembershipDisplayComponent {
    value = input<ColumnValue>();
    row = input<TableRowData>();
    column = input<ColumnConfig>();
    index = input<number>(0);
    parentRow = input<TableRowData>();
    tooltipKey = input<string>(
        'INCOMING-GOODS.BUNDLE-GROUPS.GROUPED-BUNDLE-HINT'
    );

    isGrouped(): boolean {
        return !!this.value();
    }
}
